import { getApiClient } from "@src/api";
import { graphql } from "@src/gql";

const findUserByEmail = graphql(`
	query FindByEmailQuery($email: String!) {
		users {
			users(where: { email: { eq: $email } }) {
				nodes {
					activationStatus
					avatarUrl
					displayName
					email
					firstName
					id
					language
					lastName
					newEmailToConfirm
					phoneNumber
					presenceColor
					timezone
					zoomSpeed
					appearance
					externalIdentities {
						id
						provider
					}
				}
			}
		}
	}
`);

export const findUserByEmailQueryFn = (
	email: string,
	fetchPolicy?: "cache-first" | "network-only",
) => {
	const client = getApiClient();

	return client.query({
		query: findUserByEmail,
		variables: { email },
		...(fetchPolicy ? { fetchPolicy } : {}),
	});
};
